query GetWorkspaces {
  workspaces {
    id
    name
    organizationType
    workspaceType
  }
}
